import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MissingCapabilityService } from './missing-capability/missing-capability.service';
import { LoaderService } from './shared/loader.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent {

    isLoading: boolean = false;
    showErrorPopup: boolean = true;
    deviceInfo = null;
    onlyWeb: boolean = false;

    constructor(
        private _loaderService: LoaderService,
        private modalService: NgbModal,
        private _activatedRoute: ActivatedRoute,
        private deviceService: DeviceDetectorService,
        private route: ActivatedRoute,
        private _router: Router,
        private _missingCapabilityService: MissingCapabilityService) {
        this._loaderService.loadingChange.subscribe(value => {
            this.isLoading = value;
            // console.log("App Component Loading is ", this.isLoading);
        });
        this.deviceInfo = this.deviceService.getDeviceInfo();
        const isDesktopDevice = this.deviceService.isDesktop();
        this._router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.route)
            .map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((event) => {
                // console.log("name of device", event)
                this.onlyWeb = event && event.onlyWeb ? event.onlyWeb : false;
                // if (this._activatedRoute.snapshot.queryParams.onlyWeb) {
                //     this.onlyWeb = this._activatedRoute.snapshot.queryParams.onlyWeb;
                //     console.log("name of device", this.onlyWeb)
                // }
                if (this.onlyWeb && !isDesktopDevice) {
                    console.log(this.onlyWeb);
                    // const modalRef = this.modalService.open(DeviceDetectorComponent, {
                    //     keyboard: false,
                    //     backdrop: 'static'
                    // });
                    this._router.navigateByUrl('/restrictMobile');

                }
            });


        // console.log("route name", this.route);
        this._missingCapabilityService.modal.subscribe(value => {
            // console.log('im in app comp, i got the value', value);
            this.showErrorPopup = value;
        });

    }
    epicFunction() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        const isDesktopDevice = this.deviceService.isDesktop();
        const isMobile = this.deviceService.isMobile();
        const isTablet = this.deviceService.isTablet();
    }

}





// WEBPACK FOOTER //
// ./src/app/app.component.ts